// Module
var code = `<div class="table-wrapper" ng-show="show"><div class="table-overlay"><div class="table-overlay__text"><span>Loading&hellip;</span></div></div></div>`;
// Exports
export default code;